import React, {useMemo} from 'react'
import PropTypes from 'prop-types'
import Copy from '../../components/cms/copy'
import Heading from '../../components/cms/heading'
import ModuleContainer from '../../components/cms/module-container'
import ProductAnimated from './product-animated'
import {Box, useSlotRecipe} from '@chakra-ui/react3'
import productAnimatedModuleRecipe from './index.recipe'

const ProductAnimatedModule = ({
    moduleId,
    moduleType,
    pageId,
    anchor,
    heading,
    headingLevel,
    copy,
    animatedProduct,
    containerHeight,
    background,
    desktopDisplay = 'product-below-copy'
}) => {
    const layout = desktopDisplay
    const {subline, headline1, headline2, variant} = heading
    const ariaLabel = `${subline} - ${headline1} ${headline2}`

    const recipe = useSlotRecipe({recipe: productAnimatedModuleRecipe})
    const styles = useMemo(() => {
        return recipe({layout})
    }, [layout, recipe])

    return (
        <ModuleContainer
            moduleId={moduleId}
            moduleType={moduleType}
            pageId={pageId}
            anchor={anchor}
            background={background}
            css={styles.container}
            aria-label={variant !== 'hidden' ? undefined : ariaLabel}
            spacing="none"
        >
            <Box css={styles.textBox}>
                <Box css={styles.textContent}>
                    <Heading headingLevel={headingLevel} {...heading} alignment="inherit" />
                    {copy?.text && <Copy {...copy} alignment="inherit"></Copy>}
                </Box>
            </Box>
            <Box css={styles.productBox}>
                <ProductAnimated {...animatedProduct} containerHeight={containerHeight} />
            </Box>
        </ModuleContainer>
    )
}

ProductAnimatedModule.propTypes = {
    anchor: PropTypes.string,
    background: PropTypes.oneOf(['default', 'subtle', 'strong', 'inverse']),
    headingLevel: PropTypes.oneOf([1, 2, 3, 4, 5, 6]),
    heading: PropTypes.shape({
        headline1: PropTypes.string,
        headline2: PropTypes.string,
        subline: PropTypes.string,
        variant: PropTypes.string,
        alignment: PropTypes.oneOf(['left', 'center'])
    }),
    desktopDisplay: PropTypes.string,
    copy: PropTypes.shape({
        text: PropTypes.string,
        alignment: PropTypes.oneOf(['left', 'center'])
    }),
    animatedProduct: PropTypes.shape({
        imagePrefix: PropTypes.string,
        imageExtension: PropTypes.string,
        imageCount: PropTypes.number,
        imageWidth: PropTypes.number,
        imageHeight: PropTypes.number
    }),
    containerHeight: PropTypes.number,
    moduleId: PropTypes.string,
    moduleType: PropTypes.string,
    pageId: PropTypes.string
}

export default ProductAnimatedModule
